// extracted by mini-css-extract-plugin
module.exports = {"ProfileShare":"ProfileShare_ProfileShare__wnsxT","TextArea":"ProfileShare_TextArea__1IN06"};